<h1 class="ff-h1">Fagforbundets fagforeninger som har lokal tilleggskontingent</h1>
<div class="subtitle">Enkelte av Fagforbundets lokale fagforeninger har vedtatt en lokal tilleggskontingent for å dekke sine utgifter.</div>

<table class="table table--white-body">
  <thead class="table__head head">
    <tr class="head__row row">
      <th class="row__cell union">Fagforening</th>
      <th class="row__cell percentage">Trekk prosent</th>
      <th class="row__cell max-percentage-part">Maksbeløp prosentdel</th>
      <th class="row__cell max-total">Maks inkl. forsikringer</th>
    </tr>
  </thead>
  <tbody class="table__body body">
    <tr>Må få data</tr>
    <!-- @for (d of localDues; track d) {
      <tr class="body__row">
        <td class="row__cell text-capitalize">{{getOrgIdentifier(d)}}</td>
        <td class="row__cell text-right">{{d.percentageAsFloat ? d.percentageAsFloat + ' %' : '-'}}</td>
        <td class="row__cell text-right">{{d.maxAmount ? 'kr ' + d.maxAmount + ',- per mnd' : '-'}}</td>
        <td class="row__cell text-right">{{d.maxAmount && sumInsurances ? 'kr ' + (d.maxAmount + (sumInsurances/100)) + ',- per mnd' : '-'}}</td>
      </tr>
    } -->
  </tbody>
</table>
